import {
  AlfrescoApiService,
  AuthenticationService,
  TranslationService,
} from '@alfresco/adf-core';
import { Component, HostListener, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';
import { Router } from '@angular/router';
import * as CryptoJS from 'crypto-js';
import { Subject } from 'rxjs';

import { LoginComponent } from './components/login/login.component';
import { ValidateCodeComponent } from './components/validate-code/validate-code.component';
import { EventEmitterService } from './service/event-emitter-service';
import { SolicitacaoService } from './service/solicitacao/solicitacao.service';

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.css'],
})
export class AppComponent implements OnInit {
  $isLoggedIn = false; //
  $userAdminState = false;
  $isDrawerOpen = true; //
  $isPrintPage = false;

  $adm = true;
  $acervo = false;
  $solicitacao = false;

  authorityList: Array<string>;

  mostrarMenu = false;
  userActivity;
  userInactive: Subject<any> = new Subject();

  currentTime = new Date();
  year = this.currentTime.getFullYear();

  constructor(
    translationService: TranslationService,
    private authService: AuthenticationService,
    private alfrescoApiService: AlfrescoApiService,
    private solicitacaoService: SolicitacaoService,
    private router: Router,
    private dialogRef: MatDialog,
    private loginComponent: LoginComponent,
    // private validateCodeComponent: ValidateCodeComponent,
  ) {
    translationService.use('en');
    //this.solicitacaoService.handleError();
    this.setTimeout();
    this.userInactive.subscribe(() => {
      localStorage.clear();
      sessionStorage.clear();
      sessionStorage.setItem('routerpast', router.url);
      EventEmitterService.get('isLoggedIn').emit(false);
      this.router.navigate(['login']);
    });
    EventEmitterService.get('isLoggedIn').subscribe(
      (d: boolean) => {
        this.$isLoggedIn = d;
        if (this.$isLoggedIn) {
          this.getAuthority();
        }
      }
    );

    EventEmitterService.get('isPrintPage').subscribe((data => {
      this.$isPrintPage = data;
    }))
  }

  onClickAdm() {
    this.$adm = true;
    this.$acervo = false;
    this.$solicitacao = false;
  }
  onClickAcervo() {
    this.$adm = false;
    this.$acervo = true;
    this.$solicitacao = false;
  }
  onClickSolicitacao() {
    this.$adm = false;
    this.$acervo = false;
    this.$solicitacao = true;
  }

  ngOnInit() {
    this.loginComponent.mostrarMenuEmitter.subscribe(mostrar => {
      this.mostrarMenu = mostrar;
    });
    // this.validateCodeComponent.mostrarMenuEmitter.subscribe(mostrar => {
    //   this.mostrarMenu = mostrar;
    // })
  }

  onChangeDrawerState() {
    this.$isDrawerOpen = !this.$isDrawerOpen;
  }

  getItemAuthority(key: string) {
    const storedData = sessionStorage.getItem(key);

    if (storedData) {
      try {
        const bytes = CryptoJS.AES.decrypt(
          storedData,
          sessionStorage.getItem('ticket-ECM')
        );
        this.authorityList = JSON.parse(bytes.toString(CryptoJS.enc.Utf8));
        return this.authorityList;
      } catch (e) {
        sessionStorage.clear();
      }
    }else {
      return this.authorityList = null;
    }
  }

  getAuthority() {
    this.getItemAuthority('authority');

    if (
      this.authorityList.includes('LIST_GRUPO_PERMISSION') ||
      this.authorityList.includes('SUPER_USER')
    ) {
      this.$userAdminState = true;
    }
  }

  setTimeout() {
    // 3480000 = 58min
    this.userActivity = setTimeout(
      () => this.userInactive.next(undefined),
      3480000
    );
  }

  @HostListener('window:mousemove') refreshUserState() {
    clearTimeout(this.userActivity);
    this.setTimeout();
  }

  logout() {
    this.authService.logout().subscribe(() => {
      this.router.navigate(['/']);
    });
  }

  loginRoute() {
    this.router.navigate(['/login']);
  }
}



// WEBPACK FOOTER //
// /app/src/app/app.component.ts